import Image from "next/image";
import Mortgage from "@/public/icons/mortgage.svg?url";
import NoDeposit from "@/public/icons/noDeposit.svg?url";
import MoveToUK from "@/public/icons/moveToUK.svg?url";
import SelfEmployed from "@/public/icons/selfEmployed.svg?url";
import EnableToBuy from "@/public/icons/enableToBuy.svg?url";
import CreditScore from "@/public/icons/creditScore.svg?url";

const ITEMS = [
  { t: "You don't have savings for a deposit", img: NoDeposit },
  { t: "You can't get a traditional mortgage", img: Mortgage },
  { t: "You recently arrived in the UK", img: MoveToUK },
  { t: "You're in a new job or self-employed", img: SelfEmployed },
  { t: "You're stuck renting but wanting to buy", img: EnableToBuy },
  { t: "Your credit score could be better", img: CreditScore },
];

const Eligibility = () => (
  <section className="bg-landing-ivory py-16 md:py-20">
    <div className="px-5 lg:px-20 mx-auto max-w-7xl">
      <h2 className="text-3xl md:text-5xl font-bold text-landing-blue text-center mb-3">
        Who can join Keyzy?
      </h2>
      <p className="font-serif text-lg md:text-2xl text-landing-blue/70 text-center mb-10 md:mb-14">
        If a traditional mortgage isn&apos;t working out, we can probably help.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {ITEMS.map((item) => (
          <div
            key={item.t}
            className="bg-white rounded-2xl p-7 border border-landing-gray flex items-center gap-5 transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg"
          >
            <div className="w-16 h-16 flex-none relative">
              <Image src={item.img} alt="" objectFit="contain" layout="fill" />
            </div>
            <h3 className="text-lg font-bold text-landing-blue">{item.t}</h3>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Eligibility;
